import { inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GcsUploadService {
  private readonly http = inject(HttpClient);

  initiateResumableUpload(file: File, signedUrl: string): Observable<string> {
    const headers = new HttpHeaders({
      'X-Goog-Resumable': 'start',
    });

    return this.http
      .post(signedUrl, null, {
        headers,
        observe: 'response',
      })
      .pipe(
        map((response: HttpResponse<any>) => {
          const uploadUrl = response.headers.get('Location');
          if (!uploadUrl) {
            throw new Error('No upload URL found in the Location header');
          }
          return uploadUrl;
        }),
      );
  }

  uploadFileData(uploadUrl: string, file: File): Observable<number> {
    const headers = new HttpHeaders({
      'Content-Type': file.type,
    });

    return this.http
      .put(uploadUrl, file, {
        headers,
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        map((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              return Math.round((100 * event.loaded) / (event.total ?? file.size));
            case HttpEventType.Response:
              return 100;
            default:
              return 0;
          }
        }),
      );
  }
}
